export default __webpack_public_path__ + "static/media/Search.726c9c4b.svg";